import React from "react";
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {
    render() {
        const BankCustomerSearchData = this.props.BankCustomerSearchData;
        const BankCustomerData = this.props.BankCustomerData;
        const selectedDatePDF = this.props.selectedDatePDF;
        const bankName = this.props.bankName;
        const branchName = this.props.branchName;
        const months = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER']

        return (
            <div>
                <h2><center><u>Pay Past Report - RTF</u></center></h2>
                <div>&nbsp;</div>
                <h3><center>PAY PAST REPORT - RTF FOR THE MONTH OF {months[selectedDatePDF.getMonth()]} - {selectedDatePDF.getFullYear().toString()}</center></h3>
                <div>&nbsp;</div>
                <div>
                    <center>
                        <h3><center>Group: {BankCustomerSearchData.groupName}</center></h3>
                        <h3><center>Factory: {BankCustomerSearchData.factoryName}</center></h3>
                        <h3>Route :{BankCustomerSearchData.routeName === undefined ? 'All Routes' : BankCustomerSearchData.routeName}</h3>
                        <h3>Bank :{bankName === '' ? 'All Banks' : bankName.bankName}</h3>
                        <h3>Branch :{branchName === undefined || 0 ? 'All Branches' : branchName.branchName}</h3>
                    </center>
                </div>
                <div>&nbsp;</div>
                <div>
                    <Box minWidth={1050}>
                        <TableContainer >
                            <Table aria-label="caption table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Reg No</TableCell>
                                        <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Name</TableCell>
                                        <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Route</TableCell>
                                        <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Bank Code & Bank Name</TableCell>
                                        <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Branch Name & Branch Code</TableCell>
                                        <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Account Number</TableCell>
                                        <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Transaction Code</TableCell>
                                        <TableCell align={'right'} style={{ border: "1px solid #ccc" }}>Amount (LKR)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {BankCustomerData.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.registrationNumber}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.name}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.routeName}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.bankName}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.branchName}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.accountNumber}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                052 - Suppliers
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>
        );
    }
}